import { render, staticRenderFns } from "./EditShipmentsTrackingModal.vue?vue&type=template&id=6464287b"
import script from "./EditShipmentsTrackingModal.vue?vue&type=script&lang=js"
export * from "./EditShipmentsTrackingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports